export const baseApiUrl = 'https://cloud-joint-tester.plato-io.com:443/api';
export const accessToken = 'Uvj57eLpVFeyECesqOOkO9uBvadQwL6BBPnCN9xmqMTtlxIzmiXpCWDzFMESEwoB';

export default baseApiUrl;